<template lang="pug">
//- div(:class="currentView == 'chart' ? '': 'chartWrapper'")
.chartWrapper
    Button.cardBtn.textBtn(@click="toggleCurrentView" v-if="showRawBtnStyle == 'textBtn'&& withRawBtn") {{ toggleViewHint }}
    Button.iconBtn(@click="toggleCurrentView" v-if="showRawBtnStyle == 'iconBtn'&& withRawBtn" :icon="toggleViewHint") 
    template(v-if="withCard")
        template(v-if="currentView == 'chart'")
            Card.card-shadow
                template(v-if="direction == 'vertical'")
                    bar-chart(
                        :chart-data="chartData.datacollection"
                        :options="chartData.options"
                        :width="chartWidth"
                        :height="chartHeight")
                template(v-else)
                    horizontal-bar-chart(
                        :chart-data="chartData.datacollection"
                        :options="chartData.options"
                        :width="chartWidth"
                        :height="chartHeight")
        template(v-else)
            Table(:class="tableHeaderStyle" :columns="rawDataTableColumns" :data="rawDataTableData")
    template(v-else)
        template(v-if="currentView == 'chart'")
            template(v-if="direction == 'vertical'")
                bar-chart(
                    :chart-data="chartData.datacollection"
                    :options="chartData.options"
                    :width="chartWidth"
                    :height="chartHeight")
            template(v-else)
                horizontal-bar-chart(
                    :chart-data="chartData.datacollection"
                    :options="chartData.options"
                    :width="chartWidth"
                    :height="chartHeight")
        template(v-else)
            Table(:class="tableHeaderStyle" :columns="rawDataTableColumns" :data="rawDataTableData" :no-data-text="$t('main.tableNoDataText')")

    Spin(size="large" fix v-if="spinShow")
</template>
<script>
import bus from "@/libs/bus.js";

import BarChart from "@/components/barChart.js";
import HorizontalBarChart from "@/components/horizontalBarChart.js";
import { getEdgeChartData } from "@/api/monitor.js";
import numeral from "numeral";

export default {
    name: "BarChartWrapper",
    props: {
        chartType: { type: String, default: "" },
        chartTitle: { type: String, default: "" },
        titleDisplay: { type: Boolean, default: true },
        chartDataSetLabel: { type: Array, default: () => [] },
        chartDataSetLabelTranslate: { type: Boolean, default: true },
        numeralFormat: { type: String, default: "0.00a" },
        numeralFormatTooltips: { type: String, default: "" },
        numeralFormatYAxes: { type: String, default: "" },
        numeralFormatXAxes: { type: String, default: "" },
        topNSize: { type: Number, default: 5 },

        withCard: { type: Boolean, default: true },
        withPropRawBtn: {},
        chartWidth: { type: Number, default: 600 },
        chartHeight: { type: Number, default: 340 },
        direction: { type: String, default: "vertical" },
        xAxesDisplay: { type: Boolean, default: true },
        yAxesDisplay: { type: Boolean, default: true },
        xAxesGridlineDisplay: { type: Boolean, default: true },
        yAxesGridlineDisplay: { type: Boolean, default: true },
        legendDisplay: { type: Boolean, default: true },
        legendPosition: { type: String, default: "top" },
        legendAlign: { type: String, default: "center" },

        // border, 背景色, 漸層背景色
        barBorderColors: { type: Array, default: () => [] },
        barBackgroundColors: { type: Array, default: () => [] },
        barBackgroundGradientStops: { type: Array, default: () => [] },

        // 是否使用後台dataset label, 無固定數組時使用
        // 如不使用則引用前台定義的chartDataSetLabel
        useBackendDatasetLabel: { type: Boolean, default: false }
    },
    components: { BarChart, HorizontalBarChart },
    watch: {},
    created() {},
    beforeDestroy() {},
    data() {
        return {
            spinShow: false,
            chartData: {
                datacollection: {},
                options: {}
            },
            // topNSize: this.topNSize,
            nginxData: null,
            rawDataTableColumns: [],
            rawDataTableData: [],
            currentView: "chart"
        };
    },
    methods: {
        fillChartData(nginxData) {
            var self = this;
            var scales =
                this.direction == "vertical"
                    ? {
                          xAxes: [
                              {
                                  display: this.xAxesDisplay,
                                  ticks: {
                                      // callback: function (num, index, values) {
                                      //     return numeral(num).format(self.numeralFormat);
                                      // },
                                      beginAtZero: true
                                  },
                                  gridLines: {
                                      display: false
                                  }
                              }
                          ],
                          yAxes: [
                              {
                                  display: this.yAxesDisplay,
                                  ticks: {
                                      callback: function(num, index, values) {
                                          return numeral(num).format(
                                              self.numeralFormatYAxes ? self.numeralFormatYAxes : self.numeralFormat
                                          );
                                      },
                                      beginAtZero: true,
                                      maxTicksLimit: 6
                                  },
                                  gridLines: {
                                      display: true,
                                      color: "#f0f0f0"
                                  },
                                  min: 0
                              }
                          ]
                      }
                    : {
                          yAxes: [
                              {
                                  display: this.yAxesDisplay,
                                  ticks: {
                                      // callback: function (num, index, values) {
                                      //     return numeral(num).format(self.numeralFormat);
                                      // },
                                      beginAtZero: true
                                  },
                                  gridLines: {
                                      display: false
                                  }
                              }
                          ],
                          xAxes: [
                              {
                                  display: this.xAxesDisplay,
                                  ticks: {
                                      callback: function(num, index, values) {
                                          return numeral(num).format(
                                              self.numeralFormatXAxes ? self.numeralFormatXAxes : self.numeralFormat
                                          );
                                      },
                                      beginAtZero: true,
                                      maxTicksLimit: 6
                                  },
                                  gridLines: {
                                      display: true,
                                      color: "#f0f0f0"
                                  },
                                  min: 0
                              }
                          ]
                      };
            var datasets = nginxData.data.datasets.map((dataset, index) => {
                return {
                    label: this.useBackendDatasetLabel
                        ? dataset.label
                        : this.chartDataSetLabelTranslate
                        ? `Top${this.topNSize} ${this.$i18n.t(this.chartDataSetLabel[index])}`
                        : `Top${this.topNSize} ${this.chartDataSetLabel[index]}`,
                    // label: "",
                    data: dataset.data,
                    barPercentage: 0.3,
                    pointRadius: 0,
                    pointHoverRadius: 2,
                    backgroundColor: this.barBackgroundColors[index],
                    borderColor: this.barBorderColors[index],
                    borderWidth: 1,
                    fill: true
                };
            });

            var chartData = {
                datacollection: {
                    labels: nginxData.data.labels,
                    datasets: datasets
                },
                options: {
                    // onClick: (event, chartElement) => {
                    //     console.log("CLICK CHART");
                    // },
                    legend: {
                        onClick: (event, legendElement) => {
                            // console.log("CLICK LEGEND");
                            // console.log(legendElement);
                            // console.log(legendElement.text);
                            this.$emit("onLegendClick", legendElement.text);
                        },
                        position: this.legendPosition,
                        align: this.legendAlign
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    tooltips: {
                        enabled: true,
                        mode: "single",
                        callbacks: {
                            label: function(tooltipItems, data) {
                                // 此處因為有split datasets, 所以和pieChart用法略有不同
                                let index = tooltipItems.datasetIndex;
                                let currentLabel = data.datasets[index].label;
                                // let currentData = data.datasets[0].data[index];

                                let numeralFormat = self.numeralFormatTooltip
                                    ? self.numeralFormatTooltip
                                    : self.numeralFormat;

                                return self.direction == "vertical"
                                    ? `${currentLabel}: ${numeral(tooltipItems.yLabel).format(numeralFormat)} `
                                    : `${currentLabel}: ${numeral(tooltipItems.xLabel).format(self.numeralFormat)} `;
                            }
                        }
                    },
                    scales: scales,
                    title: {
                        display: this.titleDisplay,
                        text: this.chartTitle
                    }
                }
            };

            this.chartData = chartData;
            // console.log(this.chartData);
        },
        toggleCurrentView() {
            if (this.currentView == "chart") {
                this.currentView = "rawDataTable";
                this.rawDataTableColumns = [
                    {
                        title: this.chartTitle
                            ? this.$i18n.t(this.chartTitle)
                            : this.$i18n.t(this.chartDataSetLabel[0]),
                        key: "title"
                    },
                    {
                        title: "Value",
                        key: "value"
                    }
                ];
                let dataCollection = this.chartData.datacollection;
                this.rawDataTableData = dataCollection.datasets.map((data, i) => {
                    return {
                        title: data.label,
                        value: numeral(data.data[0]).format(this.numeralFormat)
                    };
                });
            } else {
                this.currentView = "chart";
            }
        }
    },
    mounted() {},
    computed: {
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
        showRawBtnStyle() {
            return this.$store.getters.getChartConfig.showRawBtnStyle;
        },
        withRawBtn() {
            return this.withPropRawBtn !== undefined
                ? this.withPropRawBtn
                : this.$store.getters.getChartConfig.withRawBtn;
        },
        toggleViewHint() {
            if (this.showRawBtnStyle == "textBtn") return this.currentView == "chart" ? "View Raw" : "Back To Chart";
            return this.currentView == "chart" ? "md-eye" : "md-redo";
        }
    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/dashboard/BarChartHorizontalWrapperV2.vue